import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  private headerComponents: Array<any>;
  public listener = new Subject<any>();

  constructor() {
    this.headerComponents = [];
  }

  public toggle(component) {
    this.headerComponents.forEach(
      (e) => {
        if (e['component'] === component) {
          e['show'] = !e['show'];
        } else {
          e['show'] = false;
        }
      }
    );
    this.listener.next( this.headerComponents );
  }

  public setAsHeaderComponent(component) {
    this.headerComponents.push({ component: component, show: false });
  }

  public listen() {
    return this.listener.asObservable();
  }
}
